import { Grid } from '@material-ui/core';
import { Button, CurrencyField, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { usePayablesDashboardStore } from '../../hooks/usePayablesDashboardStore';

interface IMakeAnAdjustmentModalProps {
  open: boolean;
  record: any;
  onClose: () => void;
}

export const CreateCreditMemoModal = observer(({ open, record, onClose }: IMakeAnAdjustmentModalProps) => {
  const [amount, setAmount] = useState<number>(0);
  const [notes, setNotes] = useState('');
  const { payablesApprovedStore } = usePayablesDashboardStore();

  useEffect(() => {
    if (open) {
      setNotes('');
      setAmount(record?.amount ?? 0);
    }
  }, [open]);

  const handleClose = () => {
    setAmount(0);
    setNotes('');
    onClose();
  };

  const handleSubmit = async () => {
    if (amount > record?.amount) {
      payablesApprovedStore.globalStore.notificationStore.showErrorNotification({
        message: 'Credit Memo amount cannot exceed the Payable amount.',
      });
    } else {
      await payablesApprovedStore.createCreditMemoFromPayable(record.recordId, amount, notes);
      payablesApprovedStore.counterPartyExpenseGridStore.resetAndFetchGridData();
      handleClose();
    }
  };

  return (
    <StandardDialog
      open={open}
      title="Create Credit Memo"
      subTitle="This creates a new line item with a negative amount."
      maxWidth="sm"
      handleClose={handleClose}
      dialogContent={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Invoice"
              testId="adjustment-invoice"
              variant="outlined"
              standaloneLabel
              fullWidth
              value={`CM-${record?.invoice}`}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <CurrencyField
              testId={'amount-field'}
              variant={'outlined'}
              label={'Amount'}
              standaloneLabel
              value={amount.toString()}
              onChange={(name, value) => setAmount(Number(value))}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Reference ID / Reason"
              testId="adjustment-notes"
              variant="outlined"
              standaloneLabel
              fullWidth
              multiline
              placeholder='Enter reference ID or reason'
              minRows={3}
              value={notes}
              onChange={e => setNotes(e.target.value)}
            />
          </Grid>
        </Grid>
      }
      dialogActions={
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={handleClose}
            color="primary"
            variant="outlined"
            testId="adjustment-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            testId="adjustment-submit"
            disabled={!record?.invoice || !amount || amount < 0}
          >
            Create Credit Memo
          </Button>
        </>
      }
    />
  );
});
